import React, { Component, createRef } from 'react';

// CSS
import '../Subscriptions/Subscription.scss';

// Helper
import { checkCookie } from '../../Helper/Cookies';
import { apiFetch } from '../../Helper/Api';

// Components
import Header from '../../components/Header/Header';
import { Alert, Chip } from '../../components/UI/Feedback';
import { Card } from 'primereact/card';
import { InputText } from 'primereact/inputtext';
import { Toast } from 'primereact/toast';

// Properties
const properties = require('../../properties.json');

class DeviceLimit extends Component {
    constructor(props) {
        super(props);
        this.toast = createRef(null);
    }

    state = {
        maxDevicesInput: '',
        saving: false,
        loading: true,

        // what the server last told us, so the page can say what is in force
        savedValue: null,
    }

    componentDidMount() {
        document.title = properties.site_name + " | حد الأجهزة";
        if (!checkCookie('name')) {
            window.localStorage.removeItem('currentTeacher');
            window.location.href = `/`;
            return;
        }
        apiFetch("/teachers/me")
            .then(me => {
                this.setState({
                    maxDevicesInput: me.defaultMaxDevices != null ? String(me.defaultMaxDevices) : '',
                    savedValue: me.defaultMaxDevices != null ? me.defaultMaxDevices : null,
                    loading: false,
                });
            })
            .catch(error => {
                this.setState({ loading: false });
                console.error('Error:', error);
            });
    }

    save = () => {
        const raw = (this.state.maxDevicesInput || '').trim();
        const maxDevices = raw === '' ? null : parseInt(raw, 10);
        this.setState({ saving: true });
        apiFetch("/students/device-limit-default", { method: "PUT", body: { maxDevices } })
            .then(() => {
                this.setState({ saving: false, savedValue: maxDevices });
                this.toast.current.show({ severity: 'success', summary: 'تم بنجاح', detail: 'تم حفظ حد الأجهزة الافتراضي' });
            })
            .catch(error => {
                this.setState({ saving: false });
                this.toast.current.show({ severity: 'error', summary: 'لم تتم العملية', detail: error.message || 'خطأ في الإتصال' });
            });
    }

    render() {
        const { maxDevicesInput, saving, loading, savedValue } = this.state;

        const raw = String(maxDevicesInput || '').trim();
        const dirty = raw === '' ? savedValue !== null : parseInt(raw, 10) !== savedValue;

        // what is in force right now, said in words
        const inForce =
            savedValue === null ? 'بلا حد' : savedValue === 1 ? 'جهاز واحد' : savedValue === 2 ? 'جهازين' : `${savedValue} أجهزة`;

        // the same value the teacher would type, one tap away
        const quick = [
            { label: 'جهاز واحد', value: '1' },
            { label: 'جهازين', value: '2' },
            { label: '٣ أجهزة', value: '3' },
            { label: 'بلا حد', value: '' },
        ];

        return (
            <>
                <Header pageName="حد الأجهزة" />
                <Toast ref={this.toast}></Toast>
                <div className="content">
                    <div className="container">
                        <div className="card">
                            <Card>
                                {/* the form is laid out underneath; the veil just covers
                                    it until the teacher's own setting has arrived */}
                                {loading ? (
                                    <div className="ui-form-wait" role="status">
                                        <span className="spin" aria-hidden="true"></span>
                                        <b>جاري تحميل الإعداد…</b>
                                    </div>
                                ) : null}

                                <section className="ui-sec">
                                    <h3>
                                        <span className="n"><i className="pi pi-desktop"></i></span>
                                        <span className="t">
                                            حد الأجهزة لكل طالب
                                            <small>أقصى عدد أجهزة يشتغل بيها نفس الحساب في نفس الوقت</small>
                                        </span>
                                    </h3>

                                    <div className="ui-setting">
                                        <div className="now">
                                            <span>المطبّق دلوقتي</span>
                                            <Chip kind={savedValue === null ? 'off' : 'ok'}>{inForce}</Chip>
                                        </div>

                                        <div className="field">
                                            <span className="p-float-label">
                                                <InputText
                                                    id="max-devices"
                                                    type="number"
                                                    min="1"
                                                    value={maxDevicesInput}
                                                    placeholder="بلا حد"
                                                    onChange={(e) => this.setState({ maxDevicesInput: e.target.value })}
                                                    onKeyDown={(e) => e.key === 'Enter' && this.save()}
                                                />
                                                <label htmlFor="max-devices">عدد الأجهزة</label>
                                            </span>

                                            <div className="quick">
                                                {quick.map((q) => (
                                                    <button
                                                        type="button"
                                                        key={q.label}
                                                        className={raw === q.value ? 'is-on' : undefined}
                                                        onClick={() => this.setState({ maxDevicesInput: q.value })}
                                                    >
                                                        {q.label}
                                                    </button>
                                                ))}
                                            </div>
                                        </div>

                                        <button
                                            type="button"
                                            className="ui-btn is-gold"
                                            disabled={saving || !dirty}
                                            onClick={this.save}
                                        >
                                            {saving ? <i className="pi pi-spin pi-spinner"></i> : <i className="pi pi-check"></i>}
                                            <span>{saving ? 'جاري الحفظ…' : 'حفظ'}</span>
                                        </button>
                                    </div>
                                </section>

                                <section className="ui-sec">
                                    <h3>
                                        <span className="n"><i className="pi pi-info-circle"></i></span>
                                        <span className="t">
                                            إزاي بيشتغل
                                            <small>الحالات اللي الحد ده بيتطبّق فيها</small>
                                        </span>
                                    </h3>

                                    <ul className="ui-rules">
                                        <li>
                                            <i className="pi pi-lock"></i>
                                            <span>بيتفعّل مع الفيديوهات المدفوعة اللي بتشتغل على تطبيق سطح المكتب بس.</span>
                                        </li>
                                        <li>
                                            <i className="pi pi-ban"></i>
                                            <span>لو جهاز جديد حاول يدخل بعد الوصول للحد، هيترفض لحد ما طالب يسيب مكانه أو تزوّد الحد.</span>
                                        </li>
                                        <li>
                                            <i className="pi pi-user-edit"></i>
                                            <span>تقدر تحدد رقم مختلف لطالب معيّن من صفحة تعديل بياناته، والرقم بتاعه هو اللي هيتطبّق بدل الرقم ده.</span>
                                        </li>
                                    </ul>

                                    <Alert kind="info" title="سيبه فاضي">
                                        لو الخانة فاضية، يبقى مفيش حد خالص على عدد الأجهزة.
                                    </Alert>
                                </section>
                            </Card>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default DeviceLimit;
